const carouselItems = [
  {
    title: '2024 韩漫年度精选',
    desc: '盘点今年最值得一读的韩漫推荐佳作，从热血到恋爱全收录，让你一口气看过瘾。',
    tag: '韩漫推荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20manga%20themed%20illustration%20with%20vibrant%20warm%20colors%20and%20comic%20panel%20elements%2C%20dynamic%20composition%20with%20action%20lines%2C%20soft%20cream%20background%20with%20warm%20orange%20and%20coral%20highlights%2C%20modern%20editorial%20style%2C%20Japanese%20manga%20aesthetic&width=800&height=400&seq=carousel-01&orientation=landscape',
  },
  {
    title: '日漫经典回顾',
    desc: '重温那些年我们一起追过的日漫大全，经典永不过时，每一部都是青春的印记。',
    tag: '日漫大全',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20manga%20themed%20illustration%20with%20vibrant%20warm%20colors%20and%20comic%20panel%20elements%2C%20dynamic%20composition%20with%20action%20lines%2C%20soft%20cream%20background%20with%20warm%20orange%20and%20coral%20highlights%2C%20modern%20editorial%20style%2C%20Japanese%20manga%20aesthetic&width=800&height=400&seq=carousel-02&orientation=landscape',
  },
  {
    title: '国漫崛起之路',
    desc: '国漫排行榜上的精品力作不断涌现，见证国产漫画从追赶到引领的华丽蜕变。',
    tag: '国漫排行榜',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20manga%20themed%20illustration%20with%20vibrant%20warm%20colors%20and%20comic%20panel%20elements%2C%20dynamic%20composition%20with%20action%20lines%2C%20soft%20cream%20background%20with%20warm%20orange%20and%20coral%20highlights%2C%20modern%20editorial%20style%2C%20Japanese%20manga%20aesthetic&width=800&height=400&seq=carousel-03&orientation=landscape',
  },
  {
    title: '悬疑烧脑专题',
    desc: '精心挑选高分悬疑漫画，反转不断的剧情让你欲罢不能，挑战你的推理极限。',
    tag: '分类漫画',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20manga%20themed%20illustration%20with%20vibrant%20warm%20colors%20and%20comic%20panel%20elements%2C%20dynamic%20composition%20with%20action%20lines%2C%20soft%20cream%20background%20with%20warm%20orange%20and%20coral%20highlights%2C%20modern%20editorial%20style%2C%20Japanese%20manga%20aesthetic&width=800&height=400&seq=carousel-04&orientation=landscape',
  },
  {
    title: '恋爱甜漫合集',
    desc: '甜蜜温馨的恋爱漫画专场，从校园到职场，每一段故事都让人怦然心动。',
    tag: '好看的漫画',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20manga%20themed%20illustration%20with%20vibrant%20warm%20colors%20and%20comic%20panel%20elements%2C%20dynamic%20composition%20with%20action%20lines%2C%20soft%20cream%20background%20with%20warm%20orange%20and%20coral%20highlights%2C%20modern%20editorial%20style%2C%20Japanese%20manga%20aesthetic&width=800&height=400&seq=carousel-05&orientation=landscape',
  },
  {
    title: '热血战斗盛宴',
    desc: '燃到爆炸的热血漫画大集合，战斗场面震撼人心，超燃剧情让你热血沸腾。',
    tag: '漫画分类',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20manga%20themed%20illustration%20with%20vibrant%20warm%20colors%20and%20comic%20panel%20elements%2C%20dynamic%20composition%20with%20action%20lines%2C%20soft%20cream%20background%20with%20warm%20orange%20and%20coral%20highlights%2C%20modern%20editorial%20style%2C%20Japanese%20manga%20aesthetic&width=800&height=400&seq=carousel-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">焦点专题</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            精选热门专题，带你从不同角度发现<strong>好看的漫画</strong>，每次打开都有新惊喜
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.imageUrl}
              className="group relative overflow-hidden rounded-xl border border-background-200/60 bg-background-50 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  title={`${item.title} - 土豪漫画网`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/40 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-primary-600 text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>

              <div className="p-4 md:p-5">
                <h3 className="font-serif font-semibold text-base md:text-lg text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}